import React from 'react';
import { selectWindowType, WindowTypes } from 'store/pageStore';
import { useSelector } from 'react-redux';
import { checkScreenType } from 'utils';
import {
	Modal,
	ModalContent,
	ModalFooter,
	ModalHeader,
	RegularButton,
	Typography,
} from 'fronton-react';
import { Form } from './form';
import { applicationStatusList } from './application-db';
import {
	formContainerStyles,
	fromLeftStyles,
	fromRightStyles,
	formDescriptionStyles,
} from './styles';
import { useRoughWorkForm } from './form/use-send-form';

export const ApplicationForm = () => {
	const {
		toggleModal,
		openModal,
		handleSendForm,
		currentStatus,
		isLoading,
		fetched,
	} = useRoughWorkForm();

	const screenType = useSelector(selectWindowType);
	const isMobile = checkScreenType(screenType, WindowTypes.mobile);

	return (
		<>
			<div className={formContainerStyles} id="applicationForm">
				<div className={fromLeftStyles}>
					<Typography variant="h2" as="h2">
						Заявка на бесплатную <br /> консультацию
					</Typography>
					<Typography
						className={formDescriptionStyles}
						variant={isMobile ? 'm' : 'l'}
						size="body_short"
					>
						Отправьте заявку, мы проконсультируем вас по стоимости, списку работ и
						срокам.
						<br /> Запишем на замер
					</Typography>
					<img src="https://cdn.lemanapro.ru/lmru/image/upload/v1725886105/fudzi/elbrus/images/landings/rough-work/_Arrowrightlong.png/_Arrowrightlong.png" />
				</div>
				<div className={fromRightStyles}>
					<Form onSubmit={handleSendForm} loading={isLoading} fetched={fetched} />

					<Typography variant="caption">
						Нажимая на кнопку «Отправить», вы принимаете{' '}
						<a href="https://lemanapro.ru/pravila/" target="_blank" role="link">
							Положение
						</a>{' '}
						и{' '}
						<a
							href="https://lemanapro.ru/legal/soglasie-na-obrabotku-personalnyh-dannyh/"
							target="_blank"
							role="link"
						>
							Согласие
						</a>{' '}
						на обработку персональных данных, в соответствии с{' '}
						<a
							href="https://lemanapro.ru/legal/politika-obrabotki-personalnykh-dannykh/?utm_referrer=https%3A%2F%2Flemanapro.ru%2Fuslugi%2Fgotovye-resheniya-pod-klyuch%2Fmehanizirovannaya-shtukaturka-sten%2F%3Futm_referrer%3Dhttps%253A%252F%252Fweb.telegram.org%252F"
							target="_blank"
							role="link"
						>
							Политикой
						</a>
					</Typography>
				</div>
			</div>
			<Modal modalID="menu" show={openModal} onClose={toggleModal} size="s">
				<ModalHeader title={applicationStatusList[currentStatus].title} />
				<ModalContent>{applicationStatusList[currentStatus].text}</ModalContent>
				<ModalFooter>
					<RegularButton size="l" variant="primary" wide onClick={toggleModal}>
						{applicationStatusList[currentStatus]?.action}
					</RegularButton>
				</ModalFooter>
			</Modal>
		</>
	);
};
